import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-cp-grad text-white shadow-cp-accent hover:opacity-95 border-0",
        destructive:
          "bg-[linear-gradient(135deg,#f43f5e,#e11d48)] text-white shadow-sm hover:opacity-95",
        outline:
          "border border-cp-line bg-cp-inset text-cp-fg shadow-sm hover:bg-cp-surface2",
        secondary:
          "bg-cp-inset text-cp-fg border border-cp-line shadow-sm hover:bg-cp-surface2",
        ghost: "hover:bg-cp-inset hover:text-cp-fg",
        link: "text-cp-indigo underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 rounded-[9px] px-4 py-2 text-[12.5px]",
        sm: "h-8 rounded-[7px] px-3 text-[11.5px]",
        lg: "h-10 rounded-[9px] px-8",
        icon: "h-9 w-9 rounded-[9px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
